import * as actionType from '../action-type';

const initialState = {
  data: {},
};

const laminateReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.UPDATE_LAMINATE_REPORT:
      return {
        ...state,
        data: { ...state.data, ...action.payload },
      };
    case actionType.RESET_LAMINATE_REPORT:
      return initialState;
    default:
      return state;
  }
};

export default laminateReportReducer;
